import api from "./api";

function save(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

// Export a report (csv | xlsx | pdf) with the current filters, and save it.
export async function downloadReport(reportKey, format, params = {}) {
  const res = await api.get(`/reports/${reportKey}/export`, { params: { format, ...params }, responseType: "blob" });
  const ext = format === "excel" ? "xlsx" : format;
  save(res.data, `${reportKey}.${ext}`);
}

// Authenticated blob download from an arbitrary API path (e.g. evidence ZIP/PDF).
export async function downloadPath(path, filename, params = {}) {
  const res = await api.get(path, { params, responseType: "blob" });
  save(res.data, filename);
}
